import { useContext } from 'react';
import { CatalogContext } from 'Catalog/Catalog.context';
import { Helmet } from 'react-helmet-async';
import head__setTitle from 'uitils/head__setTitle';

export default function Head() {
  const { title, lang, pageNum } = useContext(CatalogContext);
  return (
    <Helmet>
      <title>{head__setTitle(title, lang)}</title>

      {/* Fonts */}
      <link
        rel='preconnect'
        href='https://fonts.googleapis.com'
      />
      <link
        rel='preconnect'
        href='https://fonts.gstatic.com'
        crossorigin
      />
      <link
        href='https://fonts.googleapis.com/css2?family=Teko:wght@300;400;500;600;700&display=swap'
        rel='stylesheet'
      />
      <link
        rel='stylesheet'
        type='text/css'
        href='https://cdn.jsdelivr.net/gh/orioncactus/pretendard/dist/web/static/pretendard-dynamic-subset.css'
      />
    </Helmet>
  );
}
